import 'ng-csv';
import ConfigsModule, { creativesPendingVariationStorageKey } from '../../configs/configs';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import template from './creativesIndex.jade';
import VariationsServices from "../../services/variationsServices";
import angular from "angular";

export const MAX_CONCURRENT_CREATIVE_SAVES = 5;

export class CreativesIndexController {
  /* @ngInject */
  constructor($scope, $window, $stateParams, currentGame, CampaignsResource, GamesResource, SegmentsResource, $state, $auth, $filter, ggTable, $timeout, $localStorage, notify, $q, currentUser, featureFlagsHelper, hideThatProduct, Upload, allVariationsAndCreativesRetrieved,variationRenderingUtilService) {
    this.$q = $q;
    this.$timeout = $timeout;
    this.stateParams = $stateParams;
    this.$state = $state;
    this.CampaignsResource = CampaignsResource;
    this.$auth = $auth;
    this.allVariationsAndCreativesRetrieved = allVariationsAndCreativesRetrieved;
    this.variationRenderingUtilService = variationRenderingUtilService;
    this.GamesResource = GamesResource;
    this.Upload = Upload;
    this.currentUser = currentUser;
    this.shouldDisableField =  this.currentUser.value.hasRole(['GD_ACCOUNT_MANAGER', 'AGENCY']);
    this.variationsStatusFilterValue = $stateParams.variationsStatusFilterValue || 'active';
    this.searchTerm = $stateParams.searchTerm || '';
    this.isResourceBeingPersisted = false;
    this.translate = $filter('translate');
    this.apiDate = $filter('apiDate');
    this.notify = notify;
    this.$localStorage = $localStorage;
    this.featureFlagsHelper = featureFlagsHelper;
    this.activeVariationTab = null;
    this.creativesUploadQueue = [];
    this.nativeVideoUploadQueue = [];
    this.pendingCreativeSaves = [];
    this.activeCreativeSaves = 0;
    this.currentGame = currentGame;
    this.$window = $window;

    this.allowedCompanionAdSizes = [
      '1024x768',
      '768x1024',
      '480x320',
      '320x480',
      '300x250'
    ];

    if ($stateParams.gameId) {
      this.getResource($stateParams.gameId);
    } else {
      this.resource = {};
    }

    $scope.$watch('vm.activeVariationTab', (newVal) => {
      if (!newVal || !this.variations || !this.tabReadyForHashUpdate) return;
      const match = newVal.match(/^tab-(\d+)$/);
      if (match) {
        const variation = this.variations[parseInt(match[1], 10) - 1];
        if (variation && variation.id != null) {
          $window.history.replaceState(null, '', $window.location.href.replace(/#\d+(-\d+)?$/, '') + '#' + variation.id);
        }
      }
    });

    const { variationId, creativeId } = this.extractIdsFromUrl($window.location.href);
    if (variationId) {
      this.initialVariationIdFromHash = variationId;
      this.initialCreativeIdFromHash = creativeId || null;
      this.stripVariationIdFromUrl();
    }
    const storedValue = this.consumeStoredVariationId();
    if (storedValue && !this.initialVariationIdFromHash) {
      const storedMatch = String(storedValue).match(/^(\d+)(?:-(\d+))?$/);
      if (storedMatch) {
        this.initialVariationIdFromHash = storedMatch[1];
        this.initialCreativeIdFromHash = storedMatch[2] || null;
      }
    }

    const creativeIdToScroll = this.initialCreativeIdFromHash;
    const variationIdForScroll = this.initialVariationIdFromHash;
    if (creativeIdToScroll && variationIdForScroll) {
      let scrollFired = false;
      allVariationsAndCreativesRetrieved.subscribe((pristineVariations) => {
        if (scrollFired || !pristineVariations) return;
        const variationWithCreatives = pristineVariations[variationIdForScroll];
        const hasCreativesLoaded = variationWithCreatives && variationWithCreatives.creatives && variationWithCreatives.creatives.length > 0;
        if (!hasCreativesLoaded) return;
        scrollFired = true;
        this.initialCreativeIdFromHash = null;
        this.$timeout(() => {
          $scope.$broadcast('scrollToCreative', creativeIdToScroll);
        }, 300);
      });
    }
  }

  updateVariationsByStatus(status) {
    this.variationsStatusFilterValue = status;
    this.stripVariationIdFromUrl();
    this.$state.go('mirror', { extraParam: 'variationsStatusFilterValue--' + status });
  }

  getVariationRequestParam() {
    if (this.variationsStatusFilterValue === 'active') {
      return { variation_status: true, search_term: this.searchTerm };
    } else if (this.variationsStatusFilterValue === 'inactive') {
      return { variation_status: false, search_term: this.searchTerm };
    }
    return {};
  }

  filterBySearchTerm() {
    this.$state.go('mirror', { extraParam: 'searchTerm--' + this.searchTerm });
  }

  getResource(id) {
    let allCreativesFetchPromises = [];
    return this.GamesResource.one(id).get().then((res) => {
      this.resource = res;
      this.GamesResource.one(id).getList('variations', this.getVariationRequestParam())
      .then((variations) => {
        this.variations = variations.plain();
        this.variations.forEach(v => {
          v.bulkCreativesActive = undefined;
          v.start_mode = !_.isNull(v.start_date) ? 'specific_date' : 'dont_start';
          v.end_mode = !_.isNull(v.end_date) ? 'specific_date' : 'never';
          v.start_date = moment.utc(v.start_date).toDate();
          v.end_date = moment.utc(v.end_date).toDate();
          v.priority = v.priority !== 'Medium';
        });

        if (this.initialVariationIdFromHash) {
          const idx = this.variations.findIndex(v => String(v.id) === String(this.initialVariationIdFromHash));
          this.activeVariationTab = idx >= 0 ? 'tab-' + (idx + 1) : 'tab-1';
          this.initialVariationIdFromHash = null;
        } else {
          this.activeVariationTab = 'tab-1';
        }
        this.tabReadyForHashUpdate = true;

        if (this.variations.length <= 0) {
          this.variations = [
            {
              name: this.translate('variation') + ' ' + (this.variations.length + 1),
              language: '--',
              countries: [],
              start_mode: 'immediate',
              end_mode: 'never',
              is_deleted: false,
              priority: false,
            }
          ];
          return;
        }
        this.pristineVariations = {};
        this.allVariationsAndCreativesRetrieved.onNext(this.pristineVariations);
      });
    });
  }

  extractIdsFromUrl(url) {
    const match = (url || '').match(/#(\d+)(?:-(\d+))?$/);
    if (!match) return { variationId: null, creativeId: null };
    return { variationId: match[1], creativeId: match[2] || null };
  }

  stripVariationIdFromUrl() {
    const cleanedUrl = this.$window.location.href.replace(/#\d+(-\d+)?$/, '');
    this.$window.history.replaceState(null, '', cleanedUrl);
  }

  consumeStoredVariationId() {
    let storedId = null;
    try {
      storedId = this.$window.sessionStorage.getItem(creativesPendingVariationStorageKey);
      if (storedId) {
        this.$window.sessionStorage.removeItem(creativesPendingVariationStorageKey);
      }
    } catch (e) {
      storedId = this.$window.__creativesPendingVariationId;
      this.$window.__creativesPendingVariationId = null;
    }
    return storedId;
  }

  saveVariations(allCreativesPromises) {
    let allVariationsPromises = [];
    let gameId = this.stateParams.gameId;
    angular.forEach(this.variations, (variation, key) => {
      // TODO use something like attribute masking https://github.com/platanus/angular-restmod#attribute-masking
      let variationWithoutCreatives = _.omit(variation, 'creatives');
      if (variationWithoutCreatives.start_mode === 'immediate') {
        variationWithoutCreatives.start_date = moment().format('YYYY-MM-DD HH:mm:ss');
      }
      variationWithoutCreatives.start_date = moment(variationWithoutCreatives.start_date).utc().format('YYYY-MM-DD HH:mm:ss');
      if (variationWithoutCreatives.start_mode === 'dont_start') {
        delete variationWithoutCreatives.start_date;
      }
      if (variationWithoutCreatives.end_mode === 'never') {
        delete variationWithoutCreatives.end_date;
      } else {
        variationWithoutCreatives.end_date = moment(variationWithoutCreatives.end_date).utc().format('YYYY-MM-DD HH:mm:ss');
      }

      variationWithoutCreatives.priority = variationWithoutCreatives.priority === true ? 'High' : 'Medium';

      if(variationWithoutCreatives.touched || !variationWithoutCreatives.id) {
        variationWithoutCreatives.game_id = gameId;
        if (variationWithoutCreatives.language === '--'){
          variationWithoutCreatives.language = null;
        }
        let nonActiveSelectedCampaignIds = _.filter(variationWithoutCreatives.campaign_ids, existingCmp => !_.find(variationWithoutCreatives.gameCampaigns, gameCampaign => existingCmp === gameCampaign.id));
        let activeSelectedCampaignIds = _.filter(variationWithoutCreatives.gameCampaigns, campaign => campaign.selected).map(campaign => campaign.id);
        variationWithoutCreatives.campaign_ids = [...nonActiveSelectedCampaignIds, ...activeSelectedCampaignIds];
        delete variationWithoutCreatives.touched;
        delete variationWithoutCreatives.gameCampaigns;

        if(variationWithoutCreatives.id) {
          allVariationsPromises.push(this.GamesResource.one(gameId).one('variations', variationWithoutCreatives.id).customPUT(variationWithoutCreatives).then((variationsRes) => {
            return this.handleUpdatedVariation(variationsRes, variation, allCreativesPromises);
          }));
        } else {
          allVariationsPromises.push(this.GamesResource.one(gameId).post('variations', variationWithoutCreatives).then((variationsRes) => {
            return this.handleUpdatedVariation(variationsRes, variation, allCreativesPromises);
          }));
        }
      }
    })
    return allVariationsPromises;
  }

  handleUpdatedVariation(variationsRes, variation, allCreativesPromises) {
    variation.id = variationsRes.id;
    variation.campaign_ids = variationsRes.campaign_ids;

    angular.forEach(variation.creatives, (creative, key) => {
      creative.variation_id = variationsRes.id;
      allCreativesPromises.push(this.limitCreativeSave(() => this.saveCreative(creative, variationsRes.game_id)));
    });
    return allCreativesPromises;
  }

  limitCreativeSave(saveTask) {
    let deferred = this.$q.defer();
    this.pendingCreativeSaves.push(() => this.$q.when()
      .then(saveTask)
      .then(deferred.resolve, deferred.reject)
      .finally(() => {
        this.activeCreativeSaves--;
        this.startPendingCreativeSaves();
      }));
    this.startPendingCreativeSaves();
    return deferred.promise;
  }

  startPendingCreativeSaves() {
    while (this.activeCreativeSaves < MAX_CONCURRENT_CREATIVE_SAVES && this.pendingCreativeSaves.length) {
      this.activeCreativeSaves++;
      this.pendingCreativeSaves.shift()();
    }
  }


  insertActionInCreativesUploadQueue(creative, origCreative, gameId) {
    if (creative.type === 'native_banner') {
      if (creative.nativeAdMainImg) { this.creativesUploadQueue.push(_.merge({origCreative, gameId, type: 'native_banner'},_.pick(creative, ['variation_id', 'id', 'nativeAdMainImg']))); }
      if (creative.nativeAdIcon) { this.creativesUploadQueue.push(_.merge({origCreative, gameId, type: 'native_banner'},_.pick(creative, ['variation_id', 'id', 'nativeAdIcon']))); }
    } else if (creative.type === 'native_video') {
      if (creative.nativeVideoAdIcon) { this.creativesUploadQueue.push(_.merge({origCreative, gameId, type: 'native_video'},_.pick(creative, ['variation_id', 'id', 'nativeVideoAdIcon']))); }
      if (creative.nativeVideoAdMainImg) { this.creativesUploadQueue.push(_.merge({origCreative, gameId, type: 'native_video'},_.pick(creative, ['variation_id', 'id', 'nativeVideoAdMainImg']))); }
      if (creative.nativeVideoAdMainVideo) { this.nativeVideoUploadQueue.push(_.merge({origCreative, gameId, type: 'native_video'},_.pick(creative, ['variation_id', 'id', 'nativeVideoAdMainVideo']))); }
    } else if (creative.type === 'video') {
      if (creative.mainVideo) { this.creativesUploadQueue.push(_.merge({origCreative, gameId, type: 'video'},_.pick(creative, ['variation_id', 'id', 'mainVideo']))); }
    } else if (creative.type === 'audio') {
      if (creative.mainAudio) { this.creativesUploadQueue.push(_.merge({origCreative, gameId, type: 'audio'},_.pick(creative, ['variation_id', 'id', 'mainAudio']))); }
    } else if (creative.type === 'mraid_playable' || creative.type === 'mraid_banner') {
      if (creative.mraidPlayableFile) { this.creativesUploadQueue.push(_.merge({origCreative, gameId, type: creative.type},_.pick(creative, ['variation_id', 'id', 'mraidPlayableFile']))); }
    } else {
      if (creative.file) { this.creativesUploadQueue.push(_.merge({origCreative, gameId, type: 'banner'},_.pick(creative, ['variation_id', 'id', 'file']))); }
    }
  }

  insertActionInCompanionAdsUploadQueue(uploadQueue, creative, gameId, companionAd, file) {
    if (file) {
      uploadQueue.push({
        gameId: gameId,
        creative_id: creative.id,
        id: companionAd.id,
        file: file,
        variation_id: creative.variation_id
      });
    }
  }

  handleUpdatedVideoCreative(gameId, creative, companionAds) {
    let allCompanionAdsPromises = [];
    let companionAdsUploadQueue = [];
    angular.forEach(companionAds, (companionAd) => {
      // TODO add to promises list also companionAds promises, like we are doing in allCreativesPromises
      this.saveCompanionAd(gameId, creative, companionAd, allCompanionAdsPromises, companionAdsUploadQueue);
    });

    this.$q.all(allCompanionAdsPromises)
    .then(() => this.processPendingCompanionAdsUploadActions(companionAdsUploadQueue));

  }

  saveCompanionAd(gameId, creative, companionAd, allCompanionAdsPromises, companionAdsUploadQueue) {
    let file = companionAd.file;
    if(companionAd.id) {
      allCompanionAdsPromises.push(
          this.GamesResource
          .one(gameId)
          .one('variations', creative.variation_id)
          .one('creatives', creative.id)
          .one('companion-ads', companionAd.id)
          .customPUT(companionAd)
          .then((companionAdRes) => {
            this.insertActionInCompanionAdsUploadQueue(companionAdsUploadQueue, creative, gameId, companionAdRes, file);
          }));
    } else {
      allCompanionAdsPromises.push(
          this.GamesResource
          .one(gameId)
          .one('variations', creative.variation_id)
          .one('creatives', creative.id)
          .post('companion-ads', companionAd).then((companionAdRes) => {
            this.insertActionInCompanionAdsUploadQueue(companionAdsUploadQueue, creative, gameId, companionAdRes, file);
          }));
    }
  }


  getSerializeCompanionAds(creative) {
    let creativeId = creative.id;
    var arrayWithAllProperties = [];

    _.forEach(creative.companionAdsMap, (companionAd) => {
      arrayWithAllProperties.push({
        id: companionAd.id,
        size: companionAd.size,
        file: companionAd.file,
        url: companionAd.url,
        s3_url: companionAd.s3_url,
        media_creative_id: creativeId,
        media_type: companionAd.media_type,
        companion_ad_type: companionAd.companion_ad_type,
        api_framework: companionAd.api_framework,
        definition: companionAd.definition,
        is_deleted: companionAd.is_deleted,
        num_products: companionAd.num_products
      });
    });

    delete creative.companionAdsMap;

    let arrayWithExtractedProperties = _.map(arrayWithAllProperties, (obj) => {
      return _.pick(obj, ['id', 'size', 'url', 's3_url', 'media_creative_id', 'file', 'media_type', 'companion_ad_type', 'api_framework', 'definition', 'num_products']);
    });

    return _.filter(arrayWithExtractedProperties, (companionAd) => {
      return companionAd.size;
    });
  }

  saveCreative(origCreative, gameId) {
    let creative = _.clone(origCreative);

    // TODO use something like encode https://github.com/platanus/angular-restmod#encode
    creative.definition = this.serializeCreativeDefinition(creative.definition);
    creative.timestamp = undefined;
    let companionAds = [];

    if(creative.type === "video" || creative.type === "audio") {
      companionAds = this.getSerializeCompanionAds(creative);
      creative.companion_ads = creative.companion_ads || [];
    }
    if (creative.id) {
      return this.GamesResource.one(gameId).one('variations', creative.variation_id).one('creatives', creative.id).customPUT(creative)
      .then((creativeRes) => {
        if(creative.type === "video" || creative.type === "audio") {
          this.handleUpdatedVideoCreative(gameId, creativeRes, companionAds);
        }
        this.insertActionInCreativesUploadQueue(creative, origCreative, gameId);
      });
    } else {
      return this.GamesResource.one(gameId).one('variations', creative.variation_id).post('creatives', creative)
      .then((creativeRes) => {
        origCreative.id = creativeRes.id;
        creative.id = creativeRes.id;
        this.insertActionInCreativesUploadQueue(creative, origCreative, gameId);
        if(creative.type === "video" || creative.type === "audio") {
          _.forEach(companionAds, (companionAd) => {companionAd.media_creative_id = creativeRes.id});
          this.handleUpdatedVideoCreative(gameId, creativeRes, companionAds);
        }
      });

    }
  }

  serializeCreativeDefinition(definition) {
    if (_.isEmpty(definition)) {
      return null;
    } else if (_.isString(definition)) {
      return definition;
    } else {
      return JSON.stringify(definition)
    }
  }

  uploadCompanionAdFile(uploadAction) {
    return this.Upload.upload({
      url: '/api/v1/games/' + uploadAction.gameId +
          '/variations/' + uploadAction.variation_id +
          '/creatives/' + uploadAction.creative_id +
          '/companion-ads/' + uploadAction.id +
          '/upload',
      headers: {Authorization: 'Bearer ' + this.$auth.getToken(), 'Requested-From-Component': 'pepapi-frontend'},
      data: {file: uploadAction.file}
    }).then(function (response) {});
  }

  uploadCreativeFile(uploadAction) {
    if(uploadAction.type === 'native_banner') {
      if (uploadAction.nativeAdMainImg) {
        return this.Upload.upload({
          url: '/api/v1/games/' + uploadAction.gameId + '/variations/' + uploadAction.variation_id + '/creatives/' + uploadAction.id + '/upload?creative_img_type=native_ad_main_image',
          headers: {Authorization: 'Bearer ' + this.$auth.getToken(), 'Requested-From-Component': 'pepapi-frontend'},
          data: {file: uploadAction.nativeAdMainImg}
        }).then(function (response) {
        });
      }

      if (uploadAction.nativeAdIcon) {
        // TODO delaying the upload of the second image on the native creative because of problems in the backend
        // Remove this weird behavior when backend is fixed
        let deferred = this.$q.defer();
        this.$timeout(() => {
          return this.Upload.upload({
            url: '/api/v1/games/' + uploadAction.gameId + '/variations/' + uploadAction.variation_id + '/creatives/' + uploadAction.id + '/upload?creative_img_type=native_ad_icon',
            headers: {Authorization: 'Bearer ' + this.$auth.getToken(), 'Requested-From-Component': 'pepapi-frontend'},
            data: {file: uploadAction.nativeAdIcon}
          }).then(function () {
            deferred.resolve();
          }).catch(function () {
            deferred.reject();
          });
        }, 3000);
        return deferred.promise;
      }
    } else if(uploadAction.type === 'native_video') {
      if (uploadAction.nativeVideoAdMainImg) {
        return this.Upload.upload({
          url: '/api/v1/games/' + uploadAction.gameId + '/variations/' + uploadAction.variation_id + '/creatives/' + uploadAction.id + '/upload?creative_img_type=native_ad_main_image',
          headers: {Authorization: 'Bearer ' + this.$auth.getToken(), 'Requested-From-Component': 'pepapi-frontend'},
          data: {file: uploadAction.nativeVideoAdMainImg}
        }).then(function (response) {
          if (response && response.data && response.data.external_name && !uploadAction.origCreative.external_name) {
            uploadAction.origCreative.external_name = response.data.external_name;
          }
        });
      }

      if (uploadAction.nativeVideoAdIcon) {
        // TODO delaying the upload of the second image on the native creative because of problems in the backend
        // Remove this weird behavior when backend is fixed
        let deferred = this.$q.defer();
        this.$timeout(() => {
          return this.Upload.upload({
            url: '/api/v1/games/' + uploadAction.gameId + '/variations/' + uploadAction.variation_id + '/creatives/' + uploadAction.id + '/upload?creative_img_type=native_ad_icon',
            headers: {Authorization: 'Bearer ' + this.$auth.getToken(), 'Requested-From-Component': 'pepapi-frontend'},
            data: {file: uploadAction.nativeVideoAdIcon}
          }).then(function (response) {
            if (response && response.data && response.data.external_name && !uploadAction.origCreative.external_name) {
              uploadAction.origCreative.external_name = response.data.external_name;
            }
            deferred.resolve();
          }).catch(function () {
            deferred.reject();
          });
        }, 6000);
        return deferred.promise;
      }

      if (uploadAction.nativeVideoAdMainVideo) {
          return this.Upload.upload({
            url: '/api/v1/games/' + uploadAction.gameId + '/variations/' + uploadAction.variation_id + '/creatives/' + uploadAction.id + '/upload/video?creative_type=native_video',
            headers: {Authorization: 'Bearer ' + this.$auth.getToken(), 'Requested-From-Component': 'pepapi-frontend'},
            data: {file: uploadAction.nativeVideoAdMainVideo}
          }).then(function (response) {
            if (response && response.data) {
              uploadAction.origCreative.external_name = response.data.external_name;
              uploadAction.origCreative.duration = response.data.duration;
              uploadAction.origCreative.aspect_ratio = response.data.aspect_ratio;
              uploadAction.origCreative.assets = response.data.assets;
            }
          });
      }
    } else if (uploadAction.type === 'video') {
      if (uploadAction.mainVideo) {
        return this.Upload.upload({
          url: '/api/v1/games/' + uploadAction.gameId + '/variations/' + uploadAction.variation_id + '/creatives/' + uploadAction.id + '/upload/video?creative_type=video',
          headers: {Authorization: 'Bearer ' + this.$auth.getToken(), 'Requested-From-Component': 'pepapi-frontend'},
          data: {file: uploadAction.mainVideo}
        }).then(function (response) {
          if (response && response.data) {
            uploadAction.origCreative.external_name = response.data.external_name;
            uploadAction.origCreative.duration = response.data.duration;
            uploadAction.origCreative.aspect_ratio = response.data.aspect_ratio;
            uploadAction.origCreative.assets = response.data.assets;
          }
        });
      }
    } else if (uploadAction.type === 'audio') {
      if (uploadAction.mainAudio) {
        return this.Upload.upload({
          url: '/api/v1/games/' + uploadAction.gameId + '/variations/' + uploadAction.variation_id + '/creatives/' + uploadAction.id + '/upload/audio?creative_type=audio',
          headers: {Authorization: 'Bearer ' + this.$auth.getToken(), 'Requested-From-Component': 'pepapi-frontend'},
          data: {file: uploadAction.mainAudio}
        }).then(function (response) {
          if (response && response.data) {
            uploadAction.origCreative.external_name = response.data.external_name;
            uploadAction.origCreative.assets = response.data.assets;
          }
        });
      }
    } else if (uploadAction.type === 'mraid_playable') {
      if (uploadAction.mraidPlayableFile) {
        return this.Upload.upload({
          url: '/api/v1/games/' + uploadAction.gameId + '/variations/' + uploadAction.variation_id + '/creatives/' + uploadAction.id + '/upload/mraid/playable?creative_type=' + uploadAction.type,
          headers: {Authorization: 'Bearer ' + this.$auth.getToken(), 'Requested-From-Component': 'pepapi-frontend'},
          data: {file: uploadAction.mraidPlayableFile}
        }).then(function (response) {
          if (response && response.data && response.data.external_name) {
            uploadAction.origCreative.external_name = response.data.external_name;
          }
        });
      }
    } else if (uploadAction.type === 'mraid_banner') {
      if (uploadAction.mraidPlayableFile) {
        return this.Upload.upload({
          url: '/api/v1/games/' + uploadAction.gameId + '/variations/' + uploadAction.variation_id + '/creatives/' + uploadAction.id + '/upload/mraid/banner',
          headers: {Authorization: 'Bearer ' + this.$auth.getToken(), 'Requested-From-Component': 'pepapi-frontend'},
          data: {file: uploadAction.mraidPlayableFile}
        }).then(function (response) {
          if (response && response.data && response.data.external_name) {
            uploadAction.origCreative.external_name = response.data.external_name;
          }
        });
      }
    } else {
      if (uploadAction.file) {
        return this.Upload.upload({
          url: '/api/v1/games/' + uploadAction.gameId + '/variations/' + uploadAction.variation_id + '/creatives/' + uploadAction.id + '/upload',
          headers: { Authorization: 'Bearer ' + this.$auth.getToken(), 'Requested-From-Component': 'pepapi-frontend'},
          data: {file: uploadAction.file}
        }).then(function (response) {
          if (response && response.data && response.data.external_name) {
            uploadAction.origCreative.external_name = response.data.external_name;
          }
        });
      }
    }
  }

  processPendingCreativesUploadActions(uploadQueue) {
    let uploadActionPromises = [];
    _.forEach(uploadQueue, (uploadAction) => {
      uploadActionPromises.push(this.uploadCreativeFile(uploadAction));
    });
    return this.$q.all(uploadActionPromises);
  }

  processPendingCompanionAdsUploadActions(uploadQueue) {
    let uploadActionPromises = [];
    _.forEach(uploadQueue, (uploadAction) => {
      uploadActionPromises.push(this.uploadCompanionAdFile(uploadAction));
    });
    return this.$q.all(uploadActionPromises);
  }

  updatePristineVariations() {
    this.pristineVariations =
        _.reduce(this.variations , function(obj,param) {
          obj[param.id] = _.cloneDeep(param);
          return obj;
        }, {});
    this.allVariationsAndCreativesRetrieved.onNext(this.pristineVariations);
  }

  update() {
    let allCreativesPromises = [];
    let updateVariationsPromises = this.saveVariations(allCreativesPromises);
    this.$q.all(updateVariationsPromises)
    .then((allCreativesPromises) => {
      return this.$q.all(allCreativesPromises[0]);
    })
    .then(() => this.processPendingCreativesUploadActions(this.creativesUploadQueue))
    .then(() => this.processPendingCreativesUploadActions(this.nativeVideoUploadQueue))
    .then(() => this.updatePristineVariations())
    .then(() => {
      this.notify.updated('app', this.resource.name);
    })
    .catch((res) => {
      this.notify.apiError(res);
      this.isResourceBeingPersisted = false;
    })
    .finally(() => { this.isResourceBeingPersisted = false; });

  }

  save() {
    this.variationRenderingUtilService.variationTouchedCheck(this.activeVariationTab, this.variations, this.pristineVariations);
    this.creativesUploadQueue = [];
    this.nativeVideoUploadQueue = [];
    this.isResourceBeingPersisted = true;
    this.update();
  }
}

export function CreativesIndexComponent() {
  return {
    template,
    controller: CreativesIndexController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      title: '='
    },
    bindToController: true
  };
};

export default angular.module('app.components.creatives.index', [
  'ngCsv',
  ConfigsModule.name,
  ServicesModule.name,
  ResourcesModule.name,
  VariationsServices.name
])
.directive('creativesIndex', CreativesIndexComponent);



/** WEBPACK FOOTER **
 ** ./src/components/creatives/creativesIndex.js
 **/